import * as React from "react";
import Button, { ButtonProps } from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

interface LoadingButtonProps {
  spinnerColor?: string;
  className?: string;
  disabled?: boolean;
  isSubmitting?: boolean;
}

type Props = ButtonProps & LoadingButtonProps;

/**
 * The `LoadingButton` component will render a typical MUI `Button` component
 * until it is _clicked_. Once it's clicked, it will render the MUI
 * `CircularProgress` component within the `Button` until the API call is complete.
 *
 * Since button behavior and styling is dependent on the context from which it is
 * used, all styling and behavior handlers are passed from the parent component
 * that is using the `LoadingButton` component.
 */

export default class LoadingButton extends React.Component<Props> {
  static muiName = "Button";
  render() {
    const { className, spinnerColor, isSubmitting, variant, disabled, ...other } = this.props;

    return (
      <Button {...other} className={className} disabled={isSubmitting || disabled} variant={variant}>
        {isSubmitting ? <CircularProgress size={18} thickness={6} className={spinnerColor} /> : this.props.children}
      </Button>
    );
  }
}
